import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Linkify from 'react-linkify';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import Radio from '@material-ui/core/Radio';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import { ImageComponent } from './ImageComponent';
import { dataItem } from '../../data/data';
import { AppHelper } from '../../helpers/AppHelper';


export class HeadingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <div className={css(Styles.questionMainTitleContainer)}>
            <Linkify componentDecorator={(href, text, key) => AppHelper.componentDecorator(href, text, key, Styles.titleContent)}>
              {this.props.data.type === 'LABEL-BOLD' &&
                <p className={css(CommonStyles.questionMainTitle)}>{this.props.data.title}</p>
              }
              {this.props.data.type === 'LABEL' &&
                <p className={css(Styles.titleContent)}>{this.props.data.title}</p>
              }
            </Linkify>
            {this.props.showInformationPopup &&
              <div className={css(CommonStyles.questionDetailContainer, Styles.questionDetailContainerCustom)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                <p className={css(CommonStyles.questionDetailContent)}>i</p>
              </div>
            }
          </div>
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
          {this.props.data.image &&
            <div className={css(CommonStyles.outerImageContainer)}>
              <ImageComponent data={this.props.data} />
            </div>
          }
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  innerContainer: {
    marginTop: 0,
  },
  titleContent: {
    fontSize: AppTheme.subTitleSize,
    color: '#707070',
    flex:1,
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  },
  questionMainTitleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  questionDetailContainerCustom: {
    alignSelf: 'flex-end'
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/HeadingComponent.js